import React from 'react';
import { Link } from 'react-router'
import $ from 'jquery'

let config = require('config');
let logoScrolled = require('../images/logo_cabin_scrolled.svg')

class Footer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMobile:false,
      isShowFooterLogo:false
    }
  }

  componentDidMount() {
    $(window).on("resize", this.resize.bind(this))
    this.resize()
    $(window).on("scroll", this.scroll.bind(this))
    this.scroll()
  }

  componentWillUnmount() {
    $(window).off("resize")
    $(window).off("scroll")
  }

  componentDidUpdate() {
    this.resize()
  }

  render() {
    return (
      <footer>
        { !this.state.isMobile ?
            <div className="footer_inner pc">
              <div className="footer__circle">
                { this.state.isShowFooterLogo ?
                    <img className="logo_c" src={logoScrolled} alt="HAKUHODO CABIN" />
                  :null
                }
              </div>
              <div className="footer__logo">HAKUHODO CABIN</div>
              <div className="footer__contact">
                <a href="mailto:info@cabin.co.jp">CONTACT：info@cabin.co.jp</a>
              </div>
              <div className="footer__link">
                <ul>
                  <li><a href="https://www.hakuhodo.co.jp/privacy_policy/" target="_blank">PRIVACY POLICY</a></li>
                </ul>
              </div>
            </div>
          :
            <div className="footer_inner mobile">
              <div className="footer__top">
                <div className="footer__contact">
                  <a href="mailto:info@cabin.co.jp">CONTACT：info@cabin.co.jp</a>
                </div>
              </div>
              <div className="footer__bottom">
                <div className="footer__logo">HAKUHODO CABIN</div>
                <div className="footer__link"><a href="https://www.hakuhodo.co.jp/privacy_policy/" target="_blank">PRIVACY POLICY</a></div>
              </div>
            </div>
        }
      </footer>
    );
  }

  resize() {
    var w = $(window).width()
    var h = $(window).height()
    if (w < config.default.MEDIA_ALL_MOBILE) {
      if (!this.state.isMobile) {
        this.setState({ isMobile:true });
      }
    } else {
      if (this.state.isMobile) {
        this.setState({ isMobile:false });
      }
    }

    var wH = $(window).height()
    var pH = $("#content").outerHeight(true) + 60
    if (wH >= pH) {
      if (!this.state.isShowFooterLogo) {
        this.setState({ isShowFooterLogo:true })
      }
    } else {
      if (this.state.isShowFooterLogo) {
        this.setState({ isShowFooterLogo:false })
      }
    }
  }

  scroll() {
    var wH = $(window).height()
    var pH = $("#content").outerHeight(true) + 60
    if (wH >= pH) {
      if (!this.state.isShowFooterLogo) {
        this.setState({ isShowFooterLogo:true })
      }
    } else {
      if (this.state.isShowFooterLogo) {
        this.setState({ isShowFooterLogo:false })
      }
    }
  }

}

Footer.displayName = 'Footer';
Footer.propTypes = {};
Footer.defaultProps = {};

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer.js